import { useMutation, useQueryClient } from 'react-query'
import FilesAndDirectoriesService from '../../../services/FilesAndDirectoriesService'
import { useParams } from 'react-router-dom'

type DeletePayload = {
  organization: string
  project: string
  selectedProjects: string[]
}
export const useBulkDelete = (directoryPath?: string) => {
  const { org, project } = useParams()
  const queryClient = useQueryClient()

  return useMutation<any, Error, DeletePayload>({
    mutationKey: ['bulk-delete-item'],
    mutationFn: async ({ organization, project, selectedProjects }) => {
      await Promise.all(
        selectedProjects.map((name) =>
          FilesAndDirectoriesService.delete(
            organization,
            `${project}/${directoryPath ? `${directoryPath}/` : ''}${name}`,
            name.includes('.') ? 'files' : 'directories',
          ),
        ),
      )
    },
    onSuccess: () => {
      directoryPath
        ? queryClient.invalidateQueries({ queryKey: ['directory-content', org, project, directoryPath] })
        : queryClient.invalidateQueries({ queryKey: ['project-content', org, project] })
    },
  })
}
